<template>
  <div class="order-list">
    <el-card>
      <template #header>
        <div class="card-header">
          <span>商城订单管理</span>
          <el-radio-group v-model="orderStatus" @change="handleStatusChange">
            <el-radio-button value="">全部</el-radio-button>
            <el-radio-button value="0">待支付</el-radio-button>
            <el-radio-button value="1">已支付</el-radio-button>
            <el-radio-button value="2">已发货</el-radio-button>
            <el-radio-button value="3">已完成</el-radio-button>
          </el-radio-group>
        </div>
      </template>
      
      <el-table :data="orderList" style="width: 100%" v-loading="loading">
        <el-table-column prop="id" label="ID" width="80" />
        <el-table-column prop="order_no" label="订单号" />
        <el-table-column prop="user_name" label="用户" />
        <el-table-column prop="total_amount" label="金额">
          <template #default="{ row }">
            ¥{{ row.total_amount }}
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态">
          <template #default="{ row }">
            <el-tag :type="getStatusType(row.status)">
              {{ getStatusText(row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="创建时间" />
        <el-table-column label="操作" width="200">
          <template #default="{ row }">
            <el-button type="primary" size="small" @click="handleDetail(row)">详情</el-button>
            <el-button 
              v-if="row.status === 1" 
              type="success" 
              size="small" 
              @click="handleShip(row)"
            >
              发货
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      
      <el-pagination
        v-model:current-page="page"
        v-model:page-size="pageSize"
        :total="total"
        layout="total, prev, pager, next"
        style="margin-top: 20px"
        @current-change="handlePageChange"
      />
    </el-card>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { ElMessage } from 'element-plus'
import request from '../../utils/request'

export default {
  name: 'OrderList',
  setup() {
    const orderList = ref([])
    const loading = ref(false)
    const page = ref(1)
    const pageSize = ref(10)
    const total = ref(0)
    const orderStatus = ref('')
    
    const getStatusType = (status) => {
      const types = { 0: 'warning', 1: 'success', 2: 'primary', 3: 'success', '-1': 'danger' }
      return types[status] || 'info'
    }
    
    const getStatusText = (status) => {
      const texts = { 0: '待支付', 1: '已支付', 2: '已发货', 3: '已完成', '-1': '已取消' }
      return texts[status] || '未知'
    }
    
    const fetchOrders = async () => {
      loading.value = true
      try {
        const res = await request.get('/api/admin/shop-orders', {
          params: { page: page.value, limit: pageSize.value, status: orderStatus.value }
        })
        orderList.value = res.data || []
        total.value = res.total || 0
      } catch (error) {
        ElMessage.error('获取订单失败')
      } finally {
        loading.value = false
      }
    }
    
    const handleStatusChange = () => {
      page.value = 1
      fetchOrders()
    }
    
    const handlePageChange = (val) => {
      page.value = val
      fetchOrders()
    }
    
    const handleDetail = (row) => {
      // 查看详情
    }
    
    const handleShip = async (row) => {
      try {
        await request.put(`/api/admin/shop-orders/${row.id}`, { status: 2 })
        ElMessage.success('发货成功')
        fetchOrders()
      } catch (error) {
        ElMessage.error('发货失败')
      }
    }
    
    onMounted(() => {
      fetchOrders()
    })
    
    return {
      orderList,
      loading,
      page,
      pageSize,
      total,
      orderStatus,
      getStatusType,
      getStatusText,
      handleStatusChange,
      handlePageChange,
      handleDetail,
      handleShip
    }
  }
}
</script>

<style scoped>
.order-list {
  padding: 8px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 0;
  flex-wrap: wrap;
  gap: 12px;
}

.card-header span {
  font-weight: 600;
  font-size: 16px;
  color: #303133;
}
</style>
